/**
 * Utilities for handling user data
 *
 * This app keeps its user data in a `ypa-data` variable in local storage. The code
 * in this file translates that data to a format that's easy to use in other files,
 * without having to know the precise structure of ypa-data.
 */

/**
 * Gets the latest user data object.
 *
 * Some values, like the session token, can change during the page life cycle. So, we query the
 * local storage every time this is called, instead of just once on page load.
 */
const getUserData = () => {
  const ypaDataRaw = window.localStorage.getItem('ypa-data');
  if (!ypaDataRaw) {
    return null;
  }

  const ypaData = JSON.parse(`${ypaDataRaw}`);
  const baseUserInfo = ypaData?.authenticatedData?.baseUserInfo;

  return {
    guestyAccountId: baseUserInfo?.accountId,
    email: ypaData?.emailAddress,
    firstName: baseUserInfo?.firstName,
    lastName: baseUserInfo?.lastName,
    sessionToken: ypaData?.sessionToken,
    ypaUserId: baseUserInfo?.userId,
    username: baseUserInfo?.username,
    inTrial: baseUserInfo?.inTrial,
    subscribed: baseUserInfo?.subscribed,
    dayOfTrial: baseUserInfo?.dayOfTrial,
    trialEndDate: baseUserInfo?.trialEndDate,
    accountIsSuspended: ypaData?.authenticatedData?.errorCode === 16,
  };
};

export default getUserData;
